import { createSelector } from "reselect";

import { AppState } from "../rootReducer";
import {GroupState} from "./types";

//User List
const getGroupsState = (state: AppState) => state.groupsReducer;

const groupUsers = (groupsState: {[group: string]: GroupState}, group: string) => groupsState[group] ? groupsState[group].users : [];
const getPending = (groupsState: {[group: string]: GroupState}, group: string) => groupsState[group] ? groupsState[group].pending : false;
const getError = (groupsState: {[group: string]: GroupState}, group: string) => groupsState[group] ? groupsState[group].error : null;

export const getGroupUsersSelector = (group: string) => createSelector(getGroupsState, (groupsState) => groupUsers(groupsState, group));
export const getGroupPendingSelector = (group: string) => createSelector(getGroupsState,(groupsState) => getPending(groupsState, group));
export const getGroupErrorSelector = (group: string) => createSelector(getGroupsState, (groupsState) => getError(groupsState, group));
